<h1 mat-dialog-title fxLayoutAlign="start center" class="mat-warn"><mat-icon color="warn" style="margin-right: .5em;">cancel</mat-icon> {{error?.title}}</h1>
<div mat-dialog-content>
  <p>{{error?.message}}</p>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button (click)="onClick()">Ok</button>
</div>
